export default __webpack_public_path__ + "static/media/R2.5aabf8e2.JPG";